import React, { Component } from "react";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";

const REQUIRED_INPUT_FILES = [
  "IN_CARD_LOAN.csv", "IN_COLLATERAL.csv", "IN_CUSTOMER_LOAN.csv",
  "IN_DEPOSIT_BORROWING.csv", "IN_FACILITIES.csv", "IN_FORWARD_TRANSACTION.csv",
  "IN_GL.csv", "IN_INVESTMENT.csv", "IN_MM_BORROWING.csv", "IN_MM_LENDING.csv",
  "IN_OPTION_TRANSACTION.csv", "IN_OTHER_LR.csv", "IN_PAYMENT_SCHEDULE.csv",
  "IN_REPO.csv", "IN_SPOT_POSITION.csv", "IN_SWAP_TRANSACTION.csv",
  "IN_VALUE_PAPER_ISSUANCE.csv",
];

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = (props.location && props.location.state) || {};
    this.state = {
      lstInput: REQUIRED_INPUT_FILES.map((name) => ({
        input: name,
        upload_by: fileInfo.upload_by || "",
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
        select: false,
      })),
      lstOutput: [],
      isSelectAllInput: false,
      isSelectAllOutput: false,
      fileInfo: fileInfo,
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      loading: true,
      showFileDownloadError: false,
      failedDownloadsList: [],
    };
  }

  componentDidMount() {
    this.getOutputList();
  }

  getOutputList = () => {
    Http.getLiquidityV2Outputs(this.state.reportName)
      .then((res) => {
        const lstOutput = [];
        if (res && res.Success && res.Data) {
          res.Data.forEach((item) => {
            lstOutput.push({
              output_type: item.output_type,
              created: Business.convertToFullDate(item.created_time),
              select: false,
            });
          });
        }
        this.setState({ lstOutput, loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      const next = !this.state.isSelectAllInput;
      this.state.lstInput.forEach((item) => { item.select = next; });
      this.setState({ isSelectAllInput: next });
    } else {
      this.state.lstInput.forEach((item) => {
        if (item.input === inputName) item.select = !item.select;
      });
      this.forceUpdate();
    }
  };

  onSelectOutput = (outputName) => {
    if (outputName === "SELECT_ALL") {
      const next = !this.state.isSelectAllOutput;
      this.state.lstOutput.forEach((item) => { item.select = next; });
      this.setState({ isSelectAllOutput: next });
    } else {
      this.state.lstOutput.forEach((item) => {
        if (item.output_type === outputName) item.select = !item.select;
      });
      this.forceUpdate();
    }
  };

  onDownloadInputFiles = () => {
    const selected = this.state.lstInput.filter((i) => i.select);
    if (!selected.length) return;
    const fileArr = selected.map((item) =>
      Http.makeDownloadFileInfo(
        item.input,
        this.state.reportDate,
        this.state.reportName,
        "input_calculation",
        "liquidity-v2",
      )
    );
    Http.downloadAllFiles(fileArr, this.state.fileInfo.report_date, this.state.reportName)
      .then((result) => {
        if (result && result.is_error) {
          this.setState({ showFileDownloadError: true, failedDownloadsList: result.failed_files || [] });
        }
      });
  };

  onDownloadOutputFiles = () => {
    const selected = this.state.lstOutput.filter((i) => i.select);
    if (!selected.length) return;
    const fileArr = selected.map((item) =>
      Http.makeDownloadLiquidityV2SheetInfo
        ? Http.makeDownloadLiquidityV2SheetInfo(this.state.reportName, this.state.reportDate, item.output_type)
        : { name: item.output_type + ".csv", url: "" }
    );
    // For output files use downloadLiquidityV2Output per file
    selected.forEach((item) => {
      Http.downloadLiquidityV2Output(this.state.reportName, item.output_type);
    });
  };

  render() {
    const { fileInfo, reportDate, reportName, status } = this.state;
    const shortName = String(reportName).substring("LIQUIDITY_V2_".length);

    return (
      <div className="content">
        <div className="container-fluid">
          <h4 style={{ marginBottom: 20 }}>
            <strong>
              {reportDate} # {shortName} # {status}
            </strong>
          </h4>

          {/* INPUT TABLE */}
          <div className="ey-file-table-toolbar">
            <button className="ey-dl-icon-btn" onClick={this.onDownloadInputFiles}>
              <i className="pe-7s-download" />
            </button>
            <span className="ey-file-table-toolbar-label">Download selected files</span>
          </div>
          <div style={{ position: "relative", height: "300px", overflowY: "scroll", marginBottom: "30px" }}>
            <table className="table ey-file-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAllInput}
                    />
                  </th>
                  <th>No.</th>
                  <th>Input</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.lstInput.map((item, index) => (
                  <tr key={item.input}>
                    <td>
                      <input
                        type="checkbox"
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </td>
                    <td>{index + 1}</td>
                    <td className="ey-file-name">{item.input}</td>
                    <td>{item.upload_by}</td>
                    <td>{item.upload_time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* OUTPUT TABLE */}
          <div className="ey-file-table-toolbar">
            <button className="ey-dl-icon-btn" onClick={this.onDownloadOutputFiles}>
              <i className="pe-7s-download" />
            </button>
            <span className="ey-file-table-toolbar-label">Download selected files</span>
          </div>
          <div style={{ position: "relative", height: "300px", overflowY: "scroll", marginBottom: "30px" }}>
            {this.state.loading ? (
              <div style={{ height: 80 }}><Loading size="small" /></div>
            ) : (
              <table className="table ey-file-table">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={() => this.onSelectOutput("SELECT_ALL")}
                        checked={this.state.isSelectAllOutput}
                      />
                    </th>
                    <th>No.</th>
                    <th>Output</th>
                    <th>CreatedTime</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.lstOutput.map((item, index) => (
                    <tr key={item.output_type}>
                      <td>
                        <input
                          type="checkbox"
                          onChange={() => this.onSelectOutput(item.output_type)}
                          checked={item.select === true}
                        />
                      </td>
                      <td>{index + 1}</td>
                      <td className="ey-file-name">{item.output_type}</td>
                      <td>{item.created}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <Alert
          title="Some Files Failed to Download!"
          text={"Please check: " + this.state.failedDownloadsList.join(", ")}
          show={this.state.showFileDownloadError}
          onConfirm={() => this.setState({ showFileDownloadError: false })}
        />
      </div>
    );
  }
}

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/LiquidityV2/FileManagement/FileInfo.js